<div class="flex flex-col gap-12">
  <img
    src="assets/images/logo.svg"
    alt="select-method"
    class="w-14 h-14 mx-auto"
  />
  <h3 class="text-title-md-bold text-center m-0">
    {{ 'auth.selectMethod.title' | translate }}
  </h3>

  <div class="flex flex-col gap-4">
    <app-card-button
      [config]="accountActivationConfig"
      (action)="goAccountActivation()"
    ></app-card-button>
    <app-card-button
      [config]="loginConfig"
      (action)="goLogin()"
    ></app-card-button>
  </div>
</div>
